<template>
  <div class="category-mobile-container">
    <Loading v-if="$store.state.modalStore.isLoading" />
    <div class="category-mobile-header-container">
      <div class="category-mobile-header">
        <div class="category-mobile-icon">
          <img
            src="../../../assets/img/svg/icon-category.svg"
            alt="Deskripsi SVG"
          />
        </div>
        <div @click="closeModal">
          <i class="fa-solid fa-xmark"></i>
        </div>
      </div>
      <div class="text-bold">
        <div v-if="currentPage == 1 || currentPage == 3">
          Kategori
        </div>
        <div class="display-title-category" v-else>
          <div class="icon-kbli">
            <img
              :src="require(`~/assets/img/icons/${currentParentId}.png`)"
              alt=""
            />
          </div>
          <div>{{ currentParentName }}</div>
        </div>
      </div>
    </div>

    <div class="category-mobile-body" v-show="currentPage == 1">
      <div v-for="list in listUsaha" class="btn-kbli-category">
        <div class="state-category-mobile ">
          <div class="icon-kbli" @click="changeFilter(list.id, list.name)">
            <img :src="require(`~/assets/img/icons/${list.id}.png`)" alt="" />
          </div>
          <div class="desc-kbli-mobile">{{ list.name }}</div>
        </div>
      </div>
    </div>
    <div class="category-mobile-body" v-show="currentPage == 2">
      <div class="category-child-wrapper">
        <KbliList :parentId="currentParentId" :parentName="currentParentName" />
      </div>
    </div>
    <div class="category-mobile-body" v-show="currentPage == 3">
      <div class="category-tag">
        <div class="tag-container">
          <ResultBar
            :data="this.$store.state.searchStore.choosedKbli"
            :desc="'desc'"
            :onClick="id => kbliRemove(id)"
            :vertical="true"
            v-if="this.$store.state.searchStore.choosedKbli.length > 0"
          />
          <div class="non-mobile-class">
            <BtnIcons
              :path="'icon-search.png'"
              :title="'Tampilkan'"
              :position="true"
              :onClick="onSearch"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="category-mobile-footer">
      <div class="column100" v-if="currentPage == 1">
        <BtnIcons
          :path="'icon-search.png'"
          :title="'Tampilkan'"
          :position="true"
          :onClick="onSearch"
        />
      </div>
      <div class="category-mobile-footer-btn" v-if="currentPage == 2">
        <button
          type="button"
          class="btn btn__default"
          @click="backToOne()"
          style="width: 30% !important;"
        >
          Kembali
        </button>
        <button
          type="button"
          class="btn btn__red"
          @click="nextThree()"
          style="width: 60% !important;"
        >
          Tampilkan
        </button>
      </div>
      <div class="category-mobile-footer-btn" v-if="currentPage == 3">
        <button
          type="button"
          class="btn btn__default"
          @click="backToOne()"
          style="width: 30% !important;"
        >
          Tambah
        </button>
        <div style="width: 60% !important;">
          <BtnIcons
            :path="'icon-search.png'"
            :title="'Tampilkan'"
            :position="true"
            :onClick="onSearch"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ResultBar from '@/components/Organism/ResultBar.vue'
export default {
  components: {
    Loading: () => import('@/components/utils/Loading'),
    BtnIcons: () => import('@/components/Atoms/BtnIcons'),
    KbliList: () => import('@/components/Organism/KbliList'),
    ResultBar,
  },
  data() {
    return {
      forceReload: true,
      currentParentId: 0,
      currentParentName: '',
      listUsaha: [
        {
          name: 'Pertanian, Kehutanan, dan Perikanan',
          id: '1',
          sub: [
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
          ],
        },
        {
          name: 'Pertambangan dan Penggalian',
          id: '2',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Industri Pengolahan',
          id: '3',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Pengadaan Listrik, Gas, Uap/Air Panas dan Udara',
          id: '4',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Treatmen Air, Treatment Air Limbah, Treatment Udara',
          id: '5',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Konstruksi',
          id: '6',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Perdagangan Besar Dan Eceran, Reparasi dan Perbaikan',
          id: '7',
          sub: [
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
            {
              code: '00111',
              subName: 'Sub kategori 1',
            },
          ],
        },
        {
          name: 'Pengangkutan dan Pergudangan',
          id: '8',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Penyediaan Akomodasi dan Penyediaan Makanan dan Minuman',
          id: '9',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Informasi dan Komunikasi',
          id: '10',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Keuangan dan Asuransi',
          id: '11',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Real Estat',
          id: '12',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Profesional, Ilmiah dan Teknis',
          id: '13',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Penyewaan dan Sewa Guna Usaha dan Jasa',
          id: '14',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Administrasi Pemerintahan Pusat',
          id: '15',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Pendidikan',
          id: '16',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Kesehatan Manusia dan Aktivitas Mesin',
          id: '17',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Kesenian, Hiburan dan Rekreasi',
          id: '18',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Jasa Lainnya',
          id: '19',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name:
            'Aktivitas Rumah Tangga Sebagai Pemberi Kerja kepada masyarakat',
          id: '20',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
        {
          name: 'Aktivitas Badan International dan Nasional',
          id: '21',
          sub: [
            {
              code: '',
              subName: '',
            },
          ],
        },
      ],
      currentPage: 1, // 1: main, 2: choose category, 3: list choosed
    }
  },
  computed: {
    choosedKbli: {
      get: function() {
        return this.$store.state.searchStore.choosedKbli
      },
    },
  },
  methods: {
    backToOne() {
      this.currentPage = 1
    },
    nextThree() {
      this.currentPage = 3
    },
    changeFilter(id, name) {
      this.currentParentId = id
      this.currentParentName = name
      this.currentPage = 2
    },
    closeModal() {
      this.$store.commit('modalStore/closeModal', {
        name: 'categoryMobile',
      })
    },
    kbliRemove(id) {
      let data = this.$store.state.searchStore.choosedKbli

      let newData = data.filter(i => i.id != id)

      this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'choosedKbli',
        value: newData,
      })
    },
    async onSearch() {
      let query = {
        vendorName: '',
        location: '',
        status: '',
        negara: '',
        prov: '',
        kota: '',
        kec: '',
        kel: '',
        tambang: '',
        sio: '',
        k3l: '',
        kplh: '',
        poStart: '',
        poEnd: '',
        eventStart: '',
        eventEnd: '',
        spmStart: '',
        spmEnd: '',
        sioStart: '',
        sioEnd: '',
        k3lStart: '',
        k3lEnd: '',
        kplhStart: '',
        kplhEnd: '',
        gradeStart: '',
        gradeEnd: '',
        csiStart: '',
        csiEnd: '',
        k3lScore: '',
        kplhScore: '',
        kbliSub:
          this.choosedKbli && this.choosedKbli.length > 0
            ? this.paramsFormatter(
                'kbli_sub',
                this.choosedKbli.map(item => {
                  return item.id
                })
              )
            : '',
        kbliParent: '',
        iujp: '',
        ijuptl: '',
        sbujk: '',
        inubbm: '',
        siupal: '',
      }

      // await this.$store.commit('modalStore/SET_MODAL_LEVEL1', false)
      await this.$store.commit('modalStore/closeModal', {
        name: 'categoryMobile',
      })
      await this.$store.commit('level1/GET_VENDOR', { query })
      await this.$store.commit('modalStore/closeModal', {
        name: 'advanceSearch',
      })

      if (this.$route.path !== '/search-result') {
        await this.$router.push('search-result')
      }
    },
  },
}
</script>
